import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BadgeShape } from '@app/app/shared/models/badge/models/badge.enum';
import { BadgeColorScheme } from '@app/app/shared/models/badge/models/badge.model';

@Component({
  selector: 'ptl-badge-image',
  templateUrl: './badge-image.component.html',
  styleUrls: ['./badge-image.component.scss'],
})
export class BadgeImageComponent {
  @Input() imageUrl = 'assets/icons/award.svg';
  @Input() shape: BadgeShape = BadgeShape.Shield;
  @Input() colorScheme: BadgeColorScheme = {
    border: '#212529',
    background: '#ffffff',
  };
  @Input() isEditEnabled = false;

  @Output() imageChange = new EventEmitter<File>();

  protected readonly BadgeShape = BadgeShape;

  onImageChange(event: Event): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      this.imageChange.emit(file);
    }
  }
}
